
import { SavedQuery, Time } from '@/model';
import Vue from 'vue';
import users from '@/store/users';

export default Vue.extend({
  name: 'QueryList',
  components: {
  },

  props: {
    queries: { type: Array as () => SavedQuery[] | undefined },
    loading: { type: Boolean },
  },

  data() {
    return {
      headers: [
        { text: 'Id', align: 'start', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Created', value: 'time' },
        { text: 'Shared', value: 'shared' },
        { text: 'User', value: 'userId' },
      ],
      search: '',
    };
  },

  methods: {
    dateTime(t: Time) {
      return t && Time.asString(t);
    },
    click(query: SavedQuery, _) {
      this.$emit('click', query);
    },
    lookupUserName(id: number): string {
      const user = users.getters.lookup.get(id);
      return user?.displayName || '';
    },
  },
});
